export default function Icon2_4() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3884_40325)">
                <g clipPath="url(#clip1_3884_40325)">
                    <path
                        d="M18.684 38C18.4874 34.6725 19.1962 33.4938 17.1612 32.963C14.1087 32.1669 11.0095 34.8677 8.86578 33.6029C6.72203 32.338 7.47553 27.9387 7.38062 25.5811C7.28573 23.2235 3.14603 24.2029 3.34103 23.4356C3.47106 22.924 4.92033 20.9737 7.68895 17.5845C6.14949 11.3532 8.61864 6.80744 15.0965 3.9473C24.8131 -0.342858 32.1521 6.26042 34.4655 11.4999C36.7788 16.7394 34.7886 24.363 28.9407 28.3994C28.7369 29.483 28.7441 32.6725 28.9407 36"
                        stroke="#F8200C"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.372 14.2741C13.727 16.426 14.4741 17.7171 15.6135 18.1475C16.7528 18.578 18.3324 18.491 20.3521 17.8867C21.0182 20.5702 22.0637 21.5055 23.4885 20.6926C24.9134 19.8796 25.5364 18.8634 25.3577 17.6437C27.9801 17.2693 29.0023 16.1623 28.424 14.3227C27.5568 11.5632 25.2125 10.0915 24.6311 10.3482C24.0497 10.6049 22.5123 11.1992 22.1573 10.3952C21.8022 9.59107 19.8422 9.91365 18.2542 10.6148C16.6663 11.3159 17.1494 9.82355 15.1556 11.2092C13.8264 12.133 13.2319 13.1546 13.372 14.2741Z"
                        stroke="#F8200C"
                        strokeWidth="2.5"
                        strokeLinejoin="round"
                    />
                    <line x1="8.29289" y1="30.9198" x2="30.9203" y2="8.29243" stroke="#F8200C" strokeWidth="2" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3884_40325">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
                <clipPath id="clip1_3884_40325">
                    <rect width="40" height="40" fill="white" transform="translate(-6.37415 9.7832) rotate(-23.8228)" />
                </clipPath>
            </defs>
        </svg>
    );
}
